import InputTypesEnum from '../../../Enums/InputTypesEnum';
import PlanningDetailsItemService from '../../../Services/PlanningDetailsItemService';

class ResetContractedOverrideItem {
  constructor(selectedItems) {
    this.PlanningDetailIds = selectedItems.map((item) => item.PlanningDetailId);
    this.Confirmation = `This will reset the contracted override for ${selectedItems.length} item(s) to the original computed value.`;
  }
}

export default class ResetContractedOverrideWindowDescription {
  static titleForCreate = 'Reset Contracted Override';
  static titleForEdit = 'Reset Contracted Override';
  static itemType = ResetContractedOverrideItem;
  static serviceFunction = (item) => PlanningDetailsItemService.ResetContractedAssignmentsOverride(item);

  static pagesInGeneralEditWizzard = [
    {
      label: 'Confirm',
      fields: [
        {
          fieldName: 'Confirmation',
          label: 'Are you sure?',
          className: 'col-12',
          type: InputTypesEnum.TextReadOnly,
        },
      ],
    },
  ];
}
